import React from 'react';

export interface MundoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const MundoIcon: React.FC<MundoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M23.986 12.503a9.63 9.63 0 0 1-1.96 5.82c-1.906 2.532-5.024 4.177-8.541 4.177s-6.635-1.65-8.54-4.176a9.63 9.63 0 0 1-1.961-5.821c0-2.174.725-4.182 1.96-5.821C6.85 4.145 9.963 2.5 13.486 2.5s6.635 1.65 8.54 4.182a9.63 9.63 0 0 1 1.961 5.82"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.485 22.5c2.796 0 5.062-4.476 5.062-9.998s-2.266-9.997-5.062-9.997-5.062 4.476-5.062 9.997c0 5.522 2.266 9.998 5.062 9.998"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.02 6.676c-1.02.652-2.376 1.18-3.96 1.533-1.385.31-2.936.48-4.575.48s-3.196-.17-4.58-.48c-1.585-.353-2.947-.881-3.96-1.533C6.85 4.145 9.961 2.5 13.484 2.5s6.635 1.65 8.54 4.182zm0 11.647c-1.905 2.531-5.024 4.176-8.54 4.176-3.518 0-6.636-1.65-8.541-4.176 1.02-.652 2.376-1.18 3.96-1.533 1.385-.31 2.936-.48 4.58-.48s3.19.17 4.575.48c1.584.353 2.947.881 3.96 1.533zM13.485 2.5v20M2.984 12.502h21.002"/>
    </svg>
  );
};

export default MundoIcon;
